import { Col, Row } from 'react-bootstrap';
import { FoodItemList } from '../../views/menu/foodItems/FoodItemList';
export function MenuItems() {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FoodItemList />
        </Col>
      </Row>
    </>
  );
}
